<template>
  <section class="empty-state">
    <v-icon :size="size" color="mediumGray">{{icon}}</v-icon>
    <p><slot></slot></p>
  </section>
</template>

<script>
  export default{
    props: {
      icon: {
        type: String,
        default: 'assignment_late'
      },
      size: {
        type: [String, Number],
        default: '100px'
      }
    }
  }
</script>

<style lang="sass">
  @import '../../assets/style/variables'

  .empty-state
    text-align: center
    color: $mediumGray

    > .icon
      opacity: .5

    p
      margin-top: 20px
</style>
